import { OrganizationFeatureFlagsDto } from '../hooks/useGetOrganizationFeatureFlags';

/**
 * Whether the "record this game" toggle should be offered for a given court.
 *
 * Degrade-safe by design: prefer the PRECISE per-court signal
 * (`recordingCapableCourtIds`) when the API supplies a non-empty set AND we
 * know which court is selected; otherwise fall back to the coarse org-level
 * `recordingAvailable` gate. That preserves today's behaviour for an older
 * API, for orgs whose agents exist but were never provisioned to specific
 * courts, and before a court is picked — while letting a partial camera
 * rollout hide the toggle on cameraless courts with no code change.
 *
 * Ported verbatim from mobile's `isRecordingAllowed`
 * (mobile/src/features/booking-courts/components/steps/VisibilityStep.tsx).
 * The two must not drift: the API omits the field on empty/error
 * (organization.controller.ts), so "absent" and "empty" mean the same thing —
 * no precise data — on every client.
 */
export function isRecordingAllowed(
    featureFlags: OrganizationFeatureFlagsDto | undefined,
    selectedCourtId: number | undefined,
): boolean {
    const capable = featureFlags?.recordingCapableCourtIds;
    if (capable && capable.length > 0 && selectedCourtId != null) {
        return capable.includes(selectedCourtId);
    }
    return featureFlags?.recordingAvailable ?? false;
}
